import { formatWallTime } from '../../../../helpers/dateTime';
import { logger } from '../../../../helpers/logger';
import { t } from '../../../../i18n';

export const BANDING_TARGET_FIELD = 'banding_target_position_id';
export const BANDING_TIME_BAND_FIELD = 'banding_target_time_band_id';

/**
 * A band without a window has both ends null; a window across midnight is printed as sent, not reordered.
 * A half window or an unreadable end is corrupt data: logged once per band per page load, and the band shows its
 * name only.
 */
export const formatTimeBandWindow = band => {
  const { starts_at, finishes_at } = band;

  if (starts_at == null && finishes_at == null) return '';

  const start = formatWallTime(starts_at, { strict: true });
  const end = formatWallTime(finishes_at, { strict: true });

  if (!start || !end) {
    logger.errorOnce(
      `district.band_window.${band.id}`,
      `Unreadable time band window for band ${band.id}: ${starts_at}–${finishes_at}`,
    );

    return '';
  }

  return t('dash.common.time_range', { start, end });
};

export const timeBandLabel = band => {
  const timeWindow = formatTimeBandWindow(band);

  return timeWindow
    ? t('dash.admin.districts.dynamic_banding_time_band_option', { name: band.name, window: timeWindow })
    : band.name;
};
